import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'
import './permission'
import { checkPermission } from '@/utils/permission'

Vue.use(ElementUI, { size: 'medium' })
Vue.config.productionTip = false

Vue.prototype.$hasPermission = checkPermission

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
